import React from 'react';
import { GridNumberField } from './shared';
import {
  positiveInteger as posIntValidator,
  positiveNumber as posNumValidator,
} from './validators';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid2';

const FormNumberField = ({
  fullWidth,
  size,
  md,
  positiveInteger,
  positiveNumber,
  variant, // deprecated
  label,
  ...rest
}) => {
  const allowedInputValue =
    (positiveInteger && posIntValidator) || (positiveNumber && posNumValidator);

  const isInline = variant === 'inline';
  let xs = size;
  if (fullWidth) xs = 12;
  else if (isInline) xs = 3;
  return (
    <>
      {isInline && (
        <Grid size={{ xs: 12 - xs }}>
          <FormLabel>{label}</FormLabel>
        </Grid>
      )}
      <GridNumberField
        xs={xs}
        md={md ?? xs}
        fullWidth
        allowedInputValue={allowedInputValue}
        label={!isInline ? label : null}
        {...rest}
      />
    </>
  );
};

FormNumberField.defaultProps = {
  size: 6,
};

export default FormNumberField;
